 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLE_PAGE from '@/components/Text/title_page'
 import TEXTBACKMATTER003COPYRIGHT from '@/components/Text/back-matter-003-copyright'
 import TEXTCHAPTER001CHAPTER1 from '@/components/Text/chapter-001-chapter-1'
 import TEXTCHAPTER002CHAPTER2 from '@/components/Text/chapter-002-chapter-2'
 import TEXTCHAPTER003CHAPTER3 from '@/components/Text/chapter-003-chapter-3'
 import TEXTCHAPTER004CHAPTER4 from '@/components/Text/chapter-004-chapter-4'
 import TEXTCHAPTER005CHAPTER5 from '@/components/Text/chapter-005-chapter-5'
 import TEXTCHAPTER006CHAPTER6 from '@/components/Text/chapter-006-chapter-6'
 import TEXTCHAPTER007CHAPTER7 from '@/components/Text/chapter-007-chapter-7'
 import TEXTCHAPTER008CHAPTER8 from '@/components/Text/chapter-008-chapter-8'
 import TEXTCHAPTER009CHAPTER9 from '@/components/Text/chapter-009-chapter-9'
 import TEXTCHAPTER010CHAPTER10 from '@/components/Text/chapter-010-chapter-10'
 import TEXTCHAPTER011CHAPTER11 from '@/components/Text/chapter-011-chapter-11'
 import TEXTCHAPTER012CHAPTER12 from '@/components/Text/chapter-012-chapter-12'
 import TEXTCHAPTER013CHAPTER13 from '@/components/Text/chapter-013-chapter-13'
 import TEXTCHAPTER014CHAPTER14 from '@/components/Text/chapter-014-chapter-14'
 import TEXTCHAPTER015CHAPTER15 from '@/components/Text/chapter-015-chapter-15'
 import TEXTCHAPTER016CHAPTER16 from '@/components/Text/chapter-016-chapter-16'
 import TEXTCHAPTER017CHAPTER17 from '@/components/Text/chapter-017-chapter-17'
 import TEXTCHAPTER018CHAPTER18 from '@/components/Text/chapter-018-chapter-18'
 import TEXTCHAPTER019CHAPTER19 from '@/components/Text/chapter-019-chapter-19'
 import TEXTCHAPTER020CHAPTER20 from '@/components/Text/chapter-020-chapter-20'
 import TEXTCHAPTER021CHAPTER21 from '@/components/Text/chapter-021-chapter-21'
 import TEXTCHAPTER022CHAPTER22 from '@/components/Text/chapter-022-chapter-22'
 import TEXTCHAPTER023CHAPTER23 from '@/components/Text/chapter-023-chapter-23'
 import TEXTCHAPTER024CHAPTER24 from '@/components/Text/chapter-024-chapter-24'
 import TEXTCHAPTER025CHAPTER25 from '@/components/Text/chapter-025-chapter-25'
 import TEXTCHAPTER026CHAPTER26 from '@/components/Text/chapter-026-chapter-26'
 import TEXTCHAPTER027CHAPTER27 from '@/components/Text/chapter-027-chapter-27'
 import TEXTCHAPTER028CHAPTER28 from '@/components/Text/chapter-028-chapter-28'
 import TEXTCHAPTER029CHAPTER29 from '@/components/Text/chapter-029-chapter-29'
 import TEXTCHAPTER030CHAPTER30 from '@/components/Text/chapter-030-chapter-30'
 import TEXTCHAPTER031CHAPTER31 from '@/components/Text/chapter-031-chapter-31'
 import TEXTCHAPTER032CHAPTER32 from '@/components/Text/chapter-032-chapter-32'
 import TEXTCHAPTER033CHAPTER33 from '@/components/Text/chapter-033-chapter-33'
 import TEXTCHAPTER034CHAPTER34 from '@/components/Text/chapter-034-chapter-34'
 import TEXTCHAPTER035CHAPTER35 from '@/components/Text/chapter-035-chapter-35'
 import TEXTCHAPTER036CHAPTER36 from '@/components/Text/chapter-036-chapter-36'
 import TEXTCHAPTER037CHAPTER37 from '@/components/Text/chapter-037-chapter-37'
 import TEXTCHAPTER038CHAPTER38 from '@/components/Text/chapter-038-chapter-38'
 import TEXTCHAPTER039CHAPTER39 from '@/components/Text/chapter-039-chapter-39'
 import TEXTCHAPTER040CHAPTER40 from '@/components/Text/chapter-040-chapter-40'
 import TEXTCHAPTER041CHAPTER41 from '@/components/Text/chapter-041-chapter-41'
 import TEXTCHAPTER042CHAPTER42 from '@/components/Text/chapter-042-chapter-42'
 import TEXTBACKMATTER001EPILOGUE from '@/components/Text/back-matter-001-epilogue'
 import LOVE_2 from '@/components/love_2'
 import TEXTFRONTMATTER003ACKNOWLEDGMENTS from '@/components/Text/front-matter-003-acknowledgments'
 import TEXTBACKMATTER002ABOUTTHEAUTHOR from '@/components/Text/back-matter-002-about-the-author'
 import TEXTCHAP210910 from '@/components/Text/chap210910'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/cover",
 			"name" : "Text/cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Text/title_page",
 			"name" : "Text/title_page",
 			"component" : TEXTTITLE_PAGE
 		},
 		{
 			"path" : "/Text/back-matter-003-copyright",
 			"name" : "Text/back-matter-003-copyright",
 			"component" : TEXTBACKMATTER003COPYRIGHT
 		},
 		{
 			"path" : "/Text/chapter-001-chapter-1",
 			"name" : "Text/chapter-001-chapter-1",
 			"component" : TEXTCHAPTER001CHAPTER1
 		},
 		{
 			"path" : "/Text/chapter-002-chapter-2",
 			"name" : "Text/chapter-002-chapter-2",
 			"component" : TEXTCHAPTER002CHAPTER2
 		},
 		{
 			"path" : "/Text/chapter-003-chapter-3",
 			"name" : "Text/chapter-003-chapter-3",
 			"component" : TEXTCHAPTER003CHAPTER3
 		},
 		{
 			"path" : "/Text/chapter-004-chapter-4",
 			"name" : "Text/chapter-004-chapter-4",
 			"component" : TEXTCHAPTER004CHAPTER4
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js